module.exports = __webpack_public_path__ + "img/sub.b3f85d0f.png";